import * as React from "react";

export function useRenderTrack(deps: any[], label?: string) {
  React.useEffect(() => {
    if (import.meta.env.DEV) console.log("new render", label, deps);
  }, deps.flat());
}
